"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNonBookableMarkers = exports.getNonBookableLocationColor = exports.clearMarkerAnimation = exports.animateLocationMarker = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
const getNonBookableLocationColor = theme => theme.color_text_secondary;

/**
 * @param {google.maps.markers} markers
 * @param {Array} locations
 */
exports.getNonBookableLocationColor = getNonBookableLocationColor;
const updateNonBookableMarkers = (markers, locations, theme) => {
  const nonBookableIds = new _set.default((0, _map.default)(locations).call(locations, loc => loc.id));
  if (nonBookableIds.size) {
    (0, _forEach.default)(markers).call(markers, _ref => {
      let {
        marker,
        meta
      } = _ref;
      if (nonBookableIds.has(meta.location.id)) {
        marker.setIcon({
          ...marker.getIcon(),
          fillOpacity: 1,
          fillColor: getNonBookableLocationColor(theme)
        });
      }
    });
  }
};

/**
 * @param {Array<{marker: google.maps.marker, meta: object}>} markers
 * @param {String} locationId
 */
exports.updateNonBookableMarkers = updateNonBookableMarkers;
const animateLocationMarker = (markers, locationId) => {
  (0, _forEach.default)(markers).call(markers, _ref2 => {
    let {
      meta,
      marker
    } = _ref2;
    if (!marker.animating && meta.location.id === locationId) {
      meta.startAnimation();
    } else if (marker.animating) {
      meta.stopAnimation();
    }
  });
};

/**
 * @param {Array<{marker: google.maps.marker, meta: object}>} markers
 */
exports.animateLocationMarker = animateLocationMarker;
const clearMarkerAnimation = markers => {
  (0, _forEach.default)(markers).call(markers, _ref3 => {
    let {
      meta,
      marker
    } = _ref3;
    if (marker.animating) {
      meta.stopAnimation();
    }
  });
};
exports.clearMarkerAnimation = clearMarkerAnimation;